import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Ticket } from '../models/ticket.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class TicketService{
   public url: string;
   public user_id: number;

   constructor(
     public _http: Http,
     public variableService:VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.variableService.getCookie('user_id'));
   }

   getTickets()
   {
     return this._http.get(this.url+'tickets/'+this.user_id).map(res => res.json());
   }

   getTicket(id:number)
   {
     return this._http.get(this.url+'contract/'+id+'/tickets/'+this.user_id)
                     .map(res => res.json());
   }


   getAllTicketsByCustomerName(customer_name:string)
   {
     return this._http.get(this.url+'/tickets/customer/'+customer_name+'/'+this.user_id)
                     .map(res => res.json());
   }
   getAllTicketsByFolio(folio:number)
   {
     return this._http.get(this.url+'/tickets/folio/'+folio+'/'+this.user_id)
                     .map(res => res.json());
   }
   getAllTicketsByCollector(collector_name:string)
   {
     return this._http.get(this.url+'/tickets/collector/'+collector_name+'/'+this.user_id)
                     .map(res => res.json());
   }
   getAllTicketsByContract(id:number)
   {
     return this._http.get(this.url+'/tickets/contract/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }

   addTicket(ticket: Ticket)
   {
     let json = JSON.stringify(ticket);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-ticket/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateTicket(id:number,pTicket: Ticket)
   {
     let json = JSON.stringify(pTicket);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-ticket/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteTicket(id:number)
   {
     return this._http.get(this.url+'delete-ticket/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/ticket.service.ts